module.exports = __webpack_public_path__ + "img/aboutUs6_en.41619e9.jpg";